const convertToArabicNumbers = (num) => {
  return num.toString().replace(/\d/g, (digit) => "٠١٢٣٤٥٦٧٨٩"[digit]);
};

export default convertToArabicNumbers;
